import moment from 'moment';
import React from 'react';

import ArticleShareSection from '_components/ArticleShareSection';
import ImageCarousel from '_components/ImageCarousel';
import { urlFor } from '_utils/images';
import { urlForMakeProfile } from '_utils/cars';

export default function ArticleHead({ article }) {
  const images = article.images;

  return (
    <div className="shadow-card sm:shadow-none rounded">
      <div className="p-4 sm:p-0">
        <div className="flex xl:flex-row flex-col flex-col-reverse justify-between items-start gap-y-4 gap-x-8">
          <div>
            <h1 className="mb-0 text-base sm:text-2xl font-bold text-content-primary">
              {article.title}
            </h1>
            <p className="text-base sm:text-lg sm:block m-0 mt-1 text-content-secondary">
              {article.excerpt}
            </p>
          </div>
          { article.make && 
          <a href={urlForMakeProfile(article.make)} className="flex-none flex items-center text-inherit gap-x-1 order-1">
            <img className="size-12" src={urlFor(article.make.logo).format('webp').size(96,96).url()} alt="" />
            {/* <div class="lg:text-sm text-xs text-center text-content-secondary">{article.make.name}</div> */}
          </a>
          }
        </div>
        <div className="mt-2 sm:mt-5 flex justify-between items-center">
          <div className="flex gap-x-3 items-center">
            <div className="h-8 w-8 rounded-full overflow-hidden bg-os-blank-background">
              {article.author?.profileImage ? (
                <img
                  src={urlFor(article.author.profileImage)
                    ?.format('webp')
                    .url()}
                  width={article.author.profileImage?.width}
                  height={article.author.profileImage?.height}
                  className="w-full h-full object-cover"
                  alt={article.author.name}
                />
              ) : null}
            </div>
            <section>
              <div className="text-sm font-bold leading-5.5">
                {article.author?.name}
              </div>
              {article.publishDate && (
                <div className="text-xs text-content-secondary leading-4.5">
                  {moment(article.publishDate).format('DD MMM YYYY')}
                </div>
              )}
            </section>
          </div>
          <ArticleShareSection article={article} />
        </div>
      </div>
      <div className="sm:mt-8">
        <ImageCarousel sourceImages={images} />
      </div>
    </div>
  );
}
